import { hasPermission, isSuperAdmin } from './permissions';

export function getDefaultRouteForAuth(authContext) {
    if (isSuperAdmin(authContext)) {
        return { name: 'admin-dashboard' };
    }

    if (hasPermission(authContext, 'purchase.view') || hasPermission(authContext, 'sales.view') || hasPermission(authContext, 'inventory.view') || hasPermission(authContext, 'finance.ledger.view') || hasPermission(authContext, 'expense.view') || hasPermission(authContext, 'users.view') || hasPermission(authContext, 'users.manage_roles') || hasPermission(authContext, 'reports.sales.view') || hasPermission(authContext, 'reports.purchase.view') || hasPermission(authContext, 'reports.stock.view') || hasPermission(authContext, 'reports.tax.view')) {
        return { name: 'index' };
    }

    return { name: 'index' };
}

export function getDefaultRouteForAttributes(attributes, permissions = [], role = null) {
    return getDefaultRouteForAuth({ attributes, permissions, role });
}
